import { render } from "./NcrmEmailMarketingPlannerTab.vue?vue&type=template&id=4e0a35f8&scoped=true"
import script from "./NcrmEmailMarketingPlannerTab.vue?vue&type=script&lang=js"
export * from "./NcrmEmailMarketingPlannerTab.vue?vue&type=script&lang=js"

import "./NcrmEmailMarketingPlannerTab.vue?vue&type=style&index=0&id=4e0a35f8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e0a35f8"]])

export default __exports__